import React, { useState } from "react";
import "../styles/InfoDocumentos.css";
import { useAuth } from "../context/AuthContext.jsx";
import FileManager from "./FileManager.jsx";
import { Scale, Book, ExternalLink, ChevronRight, ChevronLeft } from 'lucide-react';

const InfoConstituciones = () => {
    const { isAdmin } = useAuth();
    const [activeSection, setActiveSection] = useState(null);

    const links = {
        nacional: "https://www.argentina.gob.ar/sites/default/files/derechoshumanos_publicaciones_colecciondebolsillo_01_constitucion_nacion_argentina.pdf",
        provincial: "https://www.santafe.gov.ar/index.php/web/content/download/203482/986161/"
    };

    if (activeSection === 'organica') {
        return (
            <div className="doc-page-container" style={{ '--doc-color': '#8e44ad', '--doc-bg-color': '#f5eef8' }}>
                <div className="doc-page-card">
                    <button
                        onClick={() => setActiveSection(null)}
                        style={{
                            background: 'none', border: 'none', color: '#8e44ad',
                            cursor: 'pointer', display: 'flex', alignItems: 'center',
                            marginBottom: '20px', fontWeight: 'bold', padding: 0
                        }}>
                        <ChevronLeft size={20} /> Volver a Constituciones
                    </button>
                    <div className="doc-page-header">
                        <div className="doc-page-icon"><Scale size={48} /></div>
                        <h2 className="doc-page-title">Ley Orgánica</h2>
                    </div>
                    <p className="doc-page-text">Documentos y normativas sobre la Ley Orgánica de Comunas.</p>
                    <FileManager tableName="constituciones_files" folderName="constituciones" bucketName="constituciones" isAdmin={isAdmin} />
                </div>
            </div>
        );
    }

    return (
        <div className="doc-page-container" style={{ '--doc-color': '#2c3e50', '--doc-bg-color': '#e8ecef' }}>
            <style>
                {`
        .const-card {
          padding: 24px 20px;
          background-color: #ffffff;
          border: 2px solid #e0e0e0;
          border-radius: 12px;
          cursor: pointer;
          display: flex;
          flex-direction: column;
          align-items: center;
          transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
          box-shadow: 0 4px 6px rgba(0,0,0,0.05);
          text-align: center;
          height: 100%;
        }
        .const-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 20px rgba(0,0,0,0.1);
        }
        .const-card-nacional:hover { border-color: #1565c0; }
        .const-card-provincial:hover { border-color: #00838f; }
        .const-card-organica:hover { border-color: #8e44ad; }
        .const-icon-wrap {
          margin-bottom: 20px;
          transition: transform 0.3s ease;
        }
        .const-card:hover .const-icon-wrap {
          transform: scale(1.1);
        }
        `}
            </style>
            <div className="doc-page-card" style={{ maxWidth: '900px', margin: '0 auto' }}>
                <div className="doc-page-header" style={{ justifyContent: 'center' }}>
                    <div className="doc-page-icon"><Scale size={48} /></div>
                    <h2 className="doc-page-title">Constituciones</h2>
                </div>
                <p className="doc-page-text" style={{ marginBottom: '40px', textAlign: 'center', fontSize: '1.1rem' }}>
                    Seleccione la constitución o marco normativo que desea consultar.
                </p>

                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '24px' }}>

                    <div className="const-card const-card-nacional" onClick={() => window.open(links.nacional, '_blank')}>
                        <div className="const-icon-wrap">
                            <Book size={48} color="#1565c0" />
                        </div>
                        <h3 style={{ margin: '0 0 10px 0', color: '#333', fontSize: '1.25rem' }}>Constitución Nacional</h3>
                        <p style={{ color: '#666', fontSize: '0.9rem', marginBottom: 'auto', paddingBottom: '15px' }}>
                            Documento supremo que rige la República Argentina.
                        </p>
                        <div style={{ display: 'flex', alignItems: 'center', color: '#1565c0', fontSize: '0.95rem', fontWeight: 'bold', marginTop: '15px' }}>
                            Ver Documento <ExternalLink size={18} style={{ marginLeft: '6px' }} />
                        </div>
                    </div>

                    <div className="const-card const-card-provincial" onClick={() => window.open(links.provincial, '_blank')}>
                        <div className="const-icon-wrap">
                            <Book size={48} color="#00838f" />
                        </div>
                        <h3 style={{ margin: '0 0 10px 0', color: '#333', fontSize: '1.25rem' }}>Constitución Provincial</h3>
                        <p style={{ color: '#666', fontSize: '0.9rem', marginBottom: 'auto', paddingBottom: '15px' }}>
                            Base legal e institucional de la Provincia de Santa Fe.
                        </p>
                        <div style={{ display: 'flex', alignItems: 'center', color: '#00838f', fontSize: '0.95rem', fontWeight: 'bold', marginTop: '15px' }}>
                            Ver Documento <ExternalLink size={18} style={{ marginLeft: '6px' }} />
                        </div>
                    </div>

                    <div className="const-card const-card-organica" onClick={() => setActiveSection('organica')}>
                        <div className="const-icon-wrap">
                            <Scale size={48} color="#8e44ad" />
                        </div>
                        <h3 style={{ margin: '0 0 10px 0', color: '#333', fontSize: '1.25rem' }}>Ley Orgánica</h3>
                        <p style={{ color: '#666', fontSize: '0.9rem', marginBottom: 'auto', paddingBottom: '15px' }}>
                            Normativas y disposiciones sobre la Ley Orgánica de Comunas.
                        </p>
                        <div style={{ display: 'flex', alignItems: 'center', color: '#8e44ad', fontSize: '0.95rem', fontWeight: 'bold', marginTop: '15px' }}>
                            Ir a Normativas <ChevronRight size={18} style={{ marginLeft: '4px' }} />
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};
export default InfoConstituciones;
